export const RouteTitle = Symbol('RouteTitle');
